import cx from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { ReactNode, useEffect, useState } from "react";

import { LINKS } from "@/constants/links";
import { LinkType, PageLink } from "@/types/types";
import { testLinkType } from "@/utils/helpers";

export type AnchorProps = {
  children: ReactNode;
  label?: string;
  activeClassName?: string;
  className?: string;
} & (
  | {
      href: string;
      pageLink?: never;
    }
  | {
      href?: never;
      pageLink: PageLink | string; // TODO: this | string is a dirty fix. Need to refactor the whole enum link thingy
    }
);

export const Anchor = ({
  href,
  pageLink,
  label,
  children,
  activeClassName,
  className,
}: AnchorProps) => {
  const linkType: LinkType = pageLink ? "internal" : testLinkType(href);
  const isInternal = !!pageLink || linkType === "internal";
  const _href = href ?? LINKS[pageLink];

  // TEST IF IS ACTIVE
  const router = useRouter();
  const isActive = router.pathname === _href;
  const [isLinkActive, setIsLinkActive] = useState(isActive);
  useEffect(() => {
    // Stop here if not internal link
    if (!isInternal) return;
    const handleRouteChange = () => {
      setIsLinkActive(isLinkActive);
    };
    router.events.on("routeChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, [router.pathname]);

  if (isInternal) {
    return (
      <Link href={_href} passHref legacyBehavior>
        <a
          className={cx(className, { [activeClassName]: isLinkActive })}
          aria-label={label}
        >
          {children}
        </a>
      </Link>
    );
  }

  return (
    <a className={className} href={_href} aria-label={label}>
      {children}
    </a>
  );
};
